import { ScoreSummary } from '@capturi/api-scoring'
import {
  toFilterSearchParams,
  useFilterPeriodContext,
  useFirstPhoneSegmentState,
} from '@capturi/filters'
import request, { ResponseError } from '@capturi/request'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useScoreSummaries = (): UseQueryResult<
  ScoreSummary[],
  ResponseError
> => {
  const segmentState = useFirstPhoneSegmentState()
  const { periodDef } = useFilterPeriodContext()

  return useQuery({
    queryKey: ['scoreSummaries', periodDef, segmentState.values],
    queryFn: async () => {
      const result = await request.post<{ scores: ScoreSummary[] }>(
        'insights/scores?&api-version=3.3',
        {
          json: {
            ...toFilterSearchParams({ ...segmentState.values }, periodDef),
          },
        },
      )
      return result.scores
    },
  })
}
